
import { defineComponent } from 'vue'
import Card from '../ss-card'

export default defineComponent({
    name: "bc-tab",
    emits: ['selected'],
    props: {
        title: { type: String, default: undefined }
    },
    components: { Card },
    data() {
        return {
            // 生成一个随机数作为id
            tabId: Math.random().toString(36).substr(2),
            selectIndex: 0
        }
    },
    methods: {
        tabSelect(index: number) {
            this.selectIndex = index
            // 显示对应的内容
            const body = document.getElementById('bc-tab-' + this.tabId)
            const titles = body?.children
            if(titles) {
                for(let i = 0; i < titles.length; i++) {
                    // 判断是不是 DIV 并且有 name 或者 icon 属性
                    if(titles[i].nodeName == 'DIV' && (titles[i].getAttribute('name') || titles[i].getAttribute('icon'))) {
                        const title = titles[i] as HTMLElement
                        if(i == index) {
                            title.style.display = 'block'
                            setTimeout(() => {
                                title.scrollTo(0, 0)
                            }, 100);
                        } else {
                            title.style.display = 'none'
                        }
                    }
                }
            }
            this.$emit('selected', index)
        },
        getTabLineStyle(maxIndex: number) {
            const x = maxIndex - this.selectIndex
            return `transform: translateX(calc(-${x}00% - (var(--bc-tab-margin) * 2 + 10px) * ${x}))`
        }
    },
    mounted() {
        this.tabSelect(0)
        // // 如果有效插槽项有变更（增加或减少），重选选择下当前选中的选项；方式出现没有隐藏的 DIV
        this.$watch(() => this.$slots.default ? this.$slots.default().filter(item => item.props).length : 0, () => {
            this.$nextTick(() => {
                this.tabSelect(this.selectIndex)
            })
        })
    }
})
